import script from "./ChangeCategoryDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeCategoryDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeCategoryDrawer.vue?vue&type=style&index=0&id=08bf5900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bf5900"]])

export default __exports__